import authPl from "./authPl";
import commonPl from "./commonPl";
import footerPl from "./footerPl";
import galleryPl from "./galleryPl";
import menuPl from "./menuPl";
import navigationPl from "./navigationPl";
import orderPl from "./orderPl";
import paymentPl from "./paymentPl";
import statisticsPl from "./statisticsPl";

const mainPl = {
    common: commonPl,
    navigation: navigationPl,
    menu: menuPl,
    statistics: statisticsPl,
    order: orderPl,
    payment: paymentPl,
    auth: authPl,
    gallery: galleryPl,
    footer: footerPl,
};

export default mainPl;
